var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"problem"},[(_vm.list.length>0)?_c('md-field',_vm._l((_vm.list),function(item,index){return _c('md-cell-item',{key:index,attrs:{"arrow":"","title":item.title,"no-border":index==_vm.list.length?true:false},on:{"click":function($event){return _vm.onClick(item.id)}}})}),1):_c('noth-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }